export const ComponentAPI = function(apiConfig, http, helpers){
  let self = this;
  let path = `${process.env.BASENAME}/app/api/web/component`;

  /**
   * Get components match the provided component keys
   */
  self.get = (keys, options={}) => {
      return http.get(`${path}/${keys.join(';')}`,{
          params: options
      })
  };

}
